import * as userServiceActions from './userService'

export default userServiceActions
